module.exports = __webpack_public_path__ + "static/media/nav-patients-active.6baf6bf3.svg";